import { useNavigate } from 'react-router';

export const useRedirectToCart = () => {
  const navigate = useNavigate();
  return {
    redirectToCart: () => {
      navigate('/carrinho');
    },
  };
};
